<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onLaunch, onShow } from '@dcloudio/uni-app'
import { useCommonData } from '@/stores/commom'
import { useUserStore } from '@/core/services/auth-credentials'
import { publicParamsApi } from './core/apis/base-api'
import Singlestore from '@/static/js/singlestore' // 单店小程序


import klUserAppSdk from '@/hooks/kl_user_app_sdk.js'
import initFDBase from 'fdmer'
import type { FDHostInterface } from 'fdmer'
klUserAppSdk()
initFDBase()
const fdHost: FDHostInterface = window.getFDHostInstance()


const { getSystemInfo, getLocation, getAcountInfo, reportApiFun } = useCommonData()
const {
  isApp,
  isAndroid,
  isIOS,
  receiveAddress,
  isChooseAdr,
  urlParams,
  isPc,
  pcLeft,
  pcRight,
  isFlutter,
} = storeToRefs(useCommonData())
const { setProfile, setStatusBarHeight, setPegePositionData, clearProfile } = useUserStore()
const { profile } = storeToRefs(useUserStore())

// 公共参数
const initPublicParams = async () => {
  let api = new publicParamsApi()
  api.setParams = {
    type: 'client',
    lang: 'cn',
  }
  let { data } = await api.getPublicParams()
  useCommonData().publicParams = data
}

// 在pc端的时候且屏幕宽度大于460px的时候监听页面宽度变化
const handlePcWidth = () => {
  window.addEventListener('resize', () => {
    // console.log(window.innerWidth)
    if (isPc.value && window.innerWidth > 460) {
      // 移除掉html标签中用的font-size属性
      document.documentElement.style.fontSize = ''
    }
  })
}

// 获取路由上用户信息
const getHrefUserInfo = () => {
  const urlparams = new URLSearchParams(window.location.search)
  urlParams.value = urlparams
  let uid = urlparams.get('uid') || ''
  let token = urlparams.get('token') || ''
  if (window.location.hostname === 'localhost') {
    // uid = '10000242'
    // token = '5ac457211c12db66f0f40dfdb16ed056c9955560'
    // uid = '10000224'
    // token = '92f8e5017895fe3ba9311d5b9ba1f1563df50102'
  }
  setProfile({ uid, token })
}

// 小程序检查更新
const autoUpdate = () => {










































}

// 处理微信小程序相关
const handleWeiXin = (options?: AnyObject) => {
























}

// 处理app相关
const handleApp = () => {

  new Singlestore()
  const isGroupon = window.location.pathname.split('/')[1] === 'grouponPages' ? true : false
  const isOrder = window.location.pathname === '/me/order/index' ? true : false
  const isIntegral = window.location.pathname.startsWith('/me/integral')

  const getUserInfo = () => {
    if (isApp.value) {
      let userInfo, location
      try {
        userInfo = fdHost.appParams.getUserInfo() as any
        location = fdHost.appParams.getLocation() as any
        useCommonData().appParams = fdHost.appParams.getHeaderParams()

        if (!userInfo || (!userInfo.uid && !userInfo.token)) clearProfile()
        else setProfile(userInfo)

        receiveAddress.value.lat = location.lat || ''
        receiveAddress.value.lng = location.lng || ''
      } catch (error) {
        getHrefUserInfo()
      }
    } else if (isFlutter.value) {
      const flutter = window.KLifeUserApp
      try {
        flutter.device.info((res: any) => {
          if (res.data) {
            useCommonData().appParams = res.data
          }
        })
        flutter.location.current((res: any) => {
          if (res.data) {
            receiveAddress.value.lat = res.data.latitude || ''
            receiveAddress.value.lng = res.data.longitude || ''
          }
        })
        flutter.creds.get((res: any) => {
          if (res.data) {
            const userInfo = {
              token: res.data.token,
              ...res.data.info,
            }
            setProfile(userInfo)
          } else {
            clearProfile()
          }
        })
      } catch (error) {
        getHrefUserInfo()
      }
    }
  }

  if (isFlutter.value) {
    window.KLifeUserApp.appbar.setVisibility(false)
  }

  if (isGroupon || isOrder || isIntegral) {
    if (isGroupon) {
      window.addEventListener('click', (e) => {
        setPegePositionData(e.clientX, e.clientY)
      })
    }

    if (isApp.value) {
      if (isAndroid.value) {
        fdHost.navBar.hide()
      } else if (isIOS.value) {
        setTimeout(() => {
          setStatusBarHeight(uni.getWindowInfo().statusBarHeight)
          setTimeout(() => {
            fdHost.navBar.hide()
          }, 100)
        }, 200)
      }
    }
  }

  if (isApp.value || isFlutter.value) getUserInfo()
  window.loginSuccess = getUserInfo
  window.iosLoginSuccess = getUserInfo

}

// 处理pc相关
const handelPc = () => {

  if (!isApp.value && !isFlutter.value) getHrefUserInfo()

  if (isPc.value) {
    let body = document.getElementsByTagName('body')[0]
    body.setAttribute('style', 'max-width:var(--maxW);margin:0 auto;')
    let tabbar = document.getElementsByClassName('uni-tabbar-bottom')
    let tabbarChild = document.getElementsByClassName('uni-tabbar')
    if (tabbar.length) {
      tabbar[0].setAttribute(
        'style',
        `left:${pcLeft.value}px;right:${pcRight.value}px;max-width:var(--maxW);`,
      )
    }
    if (tabbarChild.length) {
      tabbarChild[0].setAttribute(
        'style',
        `left:${pcLeft.value}px;right:${pcRight.value}px;background-color: rgb(255, 255, 255); backdrop-filter: none;"`,
      )
    }
  }

}

// 禁止放大或缩小屏幕
const forbidZoom = () => {
  document.addEventListener('keydown', function (event) {
    if (event.ctrlKey && (event.keyCode === 187 || event.keyCode === 189)) {
      event.preventDefault()
    }
  })
  document.addEventListener(
    'wheel',
    function (event) {
      if (event.ctrlKey) {
        event.preventDefault()
      }
    },
    { passive: false },
  )
  document.addEventListener(
    'dblclick',
    function (event) {
      event.preventDefault()
    },
    false,
  )
}

onLaunch((options?: AnyObject) => {
  console.log(options, 2)
  forbidZoom()
  uni.removeStorage({ key: 'merSearch' })
  getSystemInfo()
  handleWeiXin(options)
  handleApp()
  handelPc()
  initPublicParams()
})

onShow(() => {
  if (isPc.value) {
    setTimeout(() => {
      document.documentElement.removeAttribute('style')
    }, 100)
    handlePcWidth()
  }
  autoUpdate()

  if (!isApp.value && !isFlutter.value) {
    reportApiFun('onForeground')
  }
})
</script>
<style lang="scss">
@import '@/styles/base.scss';
@import '@/styles/font.scss';
@import '@/styles/common.scss';
@import '@/static/icon/iconfont.css';


body {
  overflow-x: hidden !important;
}

</style>
